import React from 'react';
import styles from './TypingIndicator.module.css';

interface TypingIndicatorProps {
  visible: boolean;
  message?: string;
  isError?: boolean;
  errorMessage?: string;
  isDisconnected?: boolean;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  visible,
  message = "Thinking",
  isError = false,
  errorMessage = "Connection error. Please check your internet connection.",
  isDisconnected = false
}) => {
  if (!visible) return null;

  // Handle disconnected state
  if (isDisconnected) {
    return (
      <div className={styles.typingIndicator}>
        <div className={styles.iconSpace}>
          <svg className={styles.disconnectedIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3" />
          </svg>
        </div>
        <div className={styles.typingContent}>
          <span className={styles.disconnectedText}>
            Disconnected. Check your internet connection.
          </span>
        </div>
      </div>
    );
  }

  // Handle error state
  if (isError) {
    return (
      <div className={styles.typingIndicator}>
        <div className={styles.iconSpace}>
          <svg className={styles.errorIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div className={styles.typingContent}>
          <span className={styles.errorText}>
            {errorMessage}
          </span>
        </div>
      </div>
    );
  }

  // Normal thinking state
  return (
    <div className={styles.typingIndicator}>
      <div className={styles.iconSpace}>
        <div className={styles.thinkingAnimation}>
          <div className={styles.thinkingPulse}></div>
          <div className={styles.thinkingCore}></div>
        </div>
      </div>
      <div className={styles.typingContent}>
        <span className={styles.typingText}>
          {message}
        </span>
      </div>
    </div>
  );
};

export default TypingIndicator;
